import { Select } from "components/base/Form";

const CompanySelector = ({ className = "", value, onChange }) => (
  <Select
    className={className}
    value={value}
    onChange={(e) => onChange(e.target.value)}
  >
    <option value="UNSET">UNSET (Share between AB and LTD)</option>
    <option value="AB">AB</option>
    <option value="LTD">LTD</option>
  </Select>
);

export default CompanySelector;
